import CoreCardGrid from './CoreCardGrid';

export { type CoreCardGridProps } from './CoreCardGrid';
export default CoreCardGrid;
